import React, { useEffect, useState } from 'react';
import './App.scss';
import AppLayout from './components/AppLayout/AppLayout';
import '@sweetalert2/theme-bootstrap-4/bootstrap-4.min.css';
import LoginApi from './components/Login/api/LoginApi';
import LoadingView from './components/LoadingView/LoadingView';
import { showLoading } from './components/LoadingView/reducers/LoadingViewReducer';
import { useHistory } from 'react-router-dom';
import BaseResponse from './app/BaseResponse';
import UserModel from './components/Login/models/UserModel';
import { useDispatch } from 'react-redux';
import { setUser } from './components/Login/reducers/UserProfileReducer';

const App: React.FunctionComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [firstLoad, setFisrtLoad] = useState(false);

  const processFirstAuthentication = () => {
    showLoading(true);

    LoginApi.GetCurrentUserInfo()
      .then((response: BaseResponse<UserModel>) => {
        if (response.success) {
          dispatch(setUser(response.data));
        } else {
          history.push("/login");
        }
      })
      .catch(() => {
        history.push("/login");
      })
      .finally(() => {
        showLoading(false);
        setFisrtLoad(true);
      })
  };

  useEffect(() => {
    processFirstAuthentication();
  }, []);

  return (
    <>
      {
        firstLoad &&
        <>
          <LoadingView></LoadingView>
          <AppLayout>
          </AppLayout>
        </>
      }
    </>
  );
}

export default App;
